
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sdks/ruby",
      function () {
        return require("private-next-pages/events/sdks/ruby.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sdks/ruby"])
      });
    }
  